<div class="h-full flex flex-col justify-between">
  <div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4 w-full">
    <h3 class="flex-1 m-0 font-semibold">{{'media.chooseMedia' | translate}}</h3>
    <flow-button class="absolute right-4 top-3" theme="light" type="button" (onClick)="onCancel()">
      <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
    </flow-button>
  </div>

  <mat-dialog-content class="py-2">
    <flow-media
      class="max-w-full"
      [isModal]="true"
      [customerIdModal]="data.customerIdModal"
      [multipleSelect]="multipleSelect"
      (mediaSelected)="onSelected($event)"
      (cancel)="onCancel()"></flow-media>
  </mat-dialog-content>

  <div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6">
    <flow-button theme="secondary" variation="outline" (onClick)="onCancel()">{{ 'global.cancel' | translate }}</flow-button>
    <flow-button theme="primary" [disabled]="!selectedMedias || selectedMedias.length === 0" (onClick)="onAdd()">
      {{ 'global.add' | translate }}
    </flow-button>
  </div>
</div>
